import { Grid, Typography } from '@mui/material';

type GridTitle = { text: string; size: number };
interface IGridTitles {
  titles: GridTitle[];
  ml?: number;
}
export const GridTitles = (props: IGridTitles) => {
  return (
    <>
      <Grid container mb={2} ml={props.ml}>
        {props.titles.map((title) => (
          <Grid key={title.text} item xs={title.size}>
            <Typography>{title?.text}</Typography>
          </Grid>
        ))}
      </Grid>
    </>
  );
};
